import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15 10.832 9.166 4.998m8.334 12.5H6.666m2.448-.78 7.224-7.225c.99-.99 1.485-1.485 1.67-2.055a2.5 2.5 0 0 0 0-1.546c-.185-.57-.68-1.065-1.67-2.055l-.177-.177c-.99-.99-1.485-1.485-2.056-1.67a2.5 2.5 0 0 0-1.545 0c-.57.185-1.065.68-2.055 1.67L3.66 10.503c-.99.99-1.485 1.485-1.67 2.056a2.5 2.5 0 0 0 0 1.545c.185.571.68 1.066 1.67 2.056l.558.557c.288.289.432.433.6.536q.226.137.482.2c.192.045.396.045.803.045h1.124c.408 0 .612 0 .804-.046q.256-.061.481-.2c.169-.102.313-.246.601-.535"
    }, null, -1)
  ]))]))
}
export default { render: render }